import { render, staticRenderFns } from "./problemProducts.vue?vue&type=template&id=a589f6d8&scoped=true&"
import script from "./problemProducts.vue?vue&type=script&lang=js&"
export * from "./problemProducts.vue?vue&type=script&lang=js&"
import style0 from "./problemProducts.vue?vue&type=style&index=0&id=a589f6d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a589f6d8",
  null
  
)

export default component.exports